/**
 * Rounds a number down to a specified number of decimal places.
 *
 * Unlike `toFixed()` which returns a string and uses banker's rounding,
 * this function always rounds down (towards zero) and returns a number.
 *
 * @param val - The number to round
 * @param precision - The number of decimal places to keep (must be non-negative)
 * @returns The number rounded down to the specified precision
 *
 * @example
 * ```typescript
 * toFixedNumber(1.2345, 2)  // returns 1.23
 * toFixedNumber(1.2999, 2)  // returns 1.29 (not 1.30)
 * toFixedNumber(1.5, 0)     // returns 1
 * toFixedNumber(123.456, 1) // returns 123.4
 * ```
 */
export const toFixedNumber = (val: number, precision: number): number => {
  const factor = 10 ** precision;
  return Math.floor(val * factor) / factor;
};
